import handleAddressFocus from './handleAddressFocus';
import handleInit from './handleInit';

/**
 * Attach interactions to every element that matches selector.
 */
if ($('.map').length) {
    $('.map').each((_, component) => {
        $(component).on('click', '.map__info', handleAddressFocus(component));
        $(window).on('load', handleInit(component));
    });
}



// WEBPACK FOOTER //
// ./src/scripts/components/map/index.js